import {
  Button,
  Grid,
  Link,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { texts } from "../../../../../general/texts";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const PrimView = ({
  value,
  onChange,
  handleStartTransaction,
  props,
  classes,
  setPrimView,
  utilitySliceState,
  selectedPrim,
}) => {
  return (
    <>
      <Grid container item md={12} xs={12}>
        <Link component={"button"} onClick={() => setPrimView(false)}>
          <ArrowBackIosNewIcon color="warning" />
        </Link>
        <Typography ml={2} className={classes.fieldTitle}>
        {texts["prompt-change-data"]}
        </Typography>
      </Grid>
      <Grid container item md={12} xs={12}>
        <Typography className={classes.fieldTitle}>{texts["title-choose-prim"]}</Typography>
      </Grid>
      <Grid container item md={12} justifyContent="flex-start">
        <TextField
          select
          label="Primi"
          value={value}
          onChange={onChange}
          color="warning"
          size="small"
          className={classes.textField}
          disabled={utilitySliceState.isLoading}
        >
          {props.utilitySliceState.prims &&
            props.utilitySliceState.prims
              .filter(
                (option) => option.serviceName !== "" && option.serviceName !== null
              )
              .map((option) => (
                <MenuItem
                  key={option.prim}
                  value={`${option.prim}-${option.serviceName}`}
                >
                  {option.serviceName + "-" + option.prim}
                </MenuItem>
              ))}
        </TextField>
      </Grid>
      <Grid item md={12} xs={12} className={classes.buttonGrid}>
        <Button
          onClick={handleStartTransaction}
          className={classes.button}
          disabled={selectedPrim.prim === ""}
        >
          {texts["title-search"]}
        </Button>
      </Grid>
    </>
  );
};

export default PrimView;
